import { Drawer, DrawerProps } from "antd";
import React from "react";
import { GetAntIcon } from "../utils/ant_icons";

interface CustomDrawerProps extends DrawerProps {
	children?: React.ReactNode;
	title: string | React.ReactNode;
	open: boolean;
	close: () => void;
}

function CustomDrawer({
	children,
	title,
	open,
	close,
	...props
}: CustomDrawerProps) {
	return (
		<Drawer
			title={title}
			open={open}
			onClose={close}
			width={"50vw"}
			closeIcon={GetAntIcon("rightarrow")}
			destroyOnClose={true}
			{...props}
		>
			{children}
		</Drawer>
	);
}

export default CustomDrawer;
